var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContiCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1990_15225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 8.33301H13.9498C13.638 7.12551 12.9938 6.02966 12.0903 5.17C11.1868 4.31034 10.0604 3.72133 8.83887 3.4699C7.61737 3.21848 6.34985 3.31471 5.18031 3.74767C4.01078 4.18063 2.98613 4.93295 2.22281 5.91916C1.45949 6.90536 0.988092 8.0859 0.862189 9.32664C0.736287 10.5674 0.960925 11.8185 1.51058 12.938C2.06023 14.0574 2.91286 15.0002 3.97158 15.6593C5.03031 16.3184 6.25266 16.6673 7.49977 16.6663H14.9998C16.1048 16.6663 17.1646 16.2274 17.946 15.446C18.7274 14.6646 19.1664 13.6047 19.1664 12.4997C19.1664 11.3946 18.7274 10.3348 17.946 9.5534C17.1646 8.77199 16.1048 8.33301 14.9998 8.33301Z",
    stroke: "#3E5692",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1990_15225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContiCreate);
export default __webpack_public_path__ + "static/media/ContiCreate.2fcfc03a5818702dca47bcdbc7ddf97d.svg";
export { ForwardRef as ReactComponent };